(function () {
  'use strict';

  const FOCUSABLE_SELECTOR = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
  ].join(',');

  function trapFocus(container, event) {
    const focusable = Array.from(container.querySelectorAll(FOCUSABLE_SELECTOR)).filter(
      (el) => !el.hasAttribute('aria-hidden') && el.offsetParent !== null,
    );

    if (focusable.length === 0) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function initMenuDrawer() {
    const trigger = document.querySelector('[data-menu-trigger]');
    const drawer = document.querySelector('[data-menu-drawer]');
    const overlay = document.querySelector('[data-menu-overlay]');
    const closeBtn = drawer && drawer.querySelector('[data-menu-close]');

    if (!trigger || !drawer || !overlay) return;

    let previouslyFocused = null;

    function open() {
      previouslyFocused = document.activeElement;
      drawer.setAttribute('data-open', 'true');
      overlay.setAttribute('data-open', 'true');
      trigger.setAttribute('aria-expanded', 'true');
      drawer.setAttribute('aria-hidden', 'false');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.classList.add('is-menu-open');

      requestAnimationFrame(() => {
        const focusTarget = closeBtn || drawer.querySelector(FOCUSABLE_SELECTOR);
        if (focusTarget) focusTarget.focus();
      });
    }

    function close() {
      drawer.setAttribute('data-open', 'false');
      overlay.setAttribute('data-open', 'false');
      trigger.setAttribute('aria-expanded', 'false');
      drawer.setAttribute('aria-hidden', 'true');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('is-menu-open');

      if (previouslyFocused && typeof previouslyFocused.focus === 'function') {
        previouslyFocused.focus();
      }
    }

    trigger.addEventListener('click', () => {
      const isOpen = drawer.getAttribute('data-open') === 'true';
      isOpen ? close() : open();
    });

    overlay.addEventListener('click', close);
    if (closeBtn) closeBtn.addEventListener('click', close);

    document.addEventListener('keydown', (event) => {
      const isOpen = drawer.getAttribute('data-open') === 'true';
      if (!isOpen) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        close();
        return;
      }

      if (event.key === 'Tab') {
        trapFocus(drawer, event);
      }
    });

    drawer.addEventListener('click', (event) => {
      const link = event.target.closest('a[href]');
      if (!link) return;
      setTimeout(close, 120);
    });
  }

  function initLocaleSwitcher() {
    document.querySelectorAll('[data-locale-switcher="dropdown"]').forEach((switcher) => {
      const trigger = switcher.querySelector('[data-locale-trigger]');
      const menu = switcher.querySelector('[data-locale-menu]');
      if (!trigger || !menu) return;

      function setOpen(open) {
        switcher.setAttribute('data-open', String(open));
        trigger.setAttribute('aria-expanded', String(open));
      }

      trigger.addEventListener('click', (event) => {
        event.stopPropagation();
        const isOpen = switcher.getAttribute('data-open') === 'true';
        setOpen(!isOpen);
      });

      document.addEventListener('click', (event) => {
        if (!switcher.contains(event.target)) {
          setOpen(false);
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && switcher.getAttribute('data-open') === 'true') {
          setOpen(false);
          trigger.focus();
        }
      });
    });
  }

  function initHeaderScroll() {
    const header = document.querySelector('[data-header]');
    const topbar = document.querySelector('.shopify-section-announcement-bar')
      || document.querySelector('.announcement-bar');
    const root = document.documentElement;

    if (!header) return;

    const SCROLL_THRESHOLD = 4;

    let lastY = window.scrollY;
    let lastDirection = 0; // -1 up, 1 down, 0 none
    let ticking = false;

    function topbarHeight() {
      return topbar ? topbar.offsetHeight : 0;
    }

    function setTopOffset(px) {
      root.style.setProperty('--header-top-offset', px + 'px');
    }

    function update() {
      const currentY = Math.max(0, window.scrollY);
      const topbarH = topbarHeight();

      if (currentY <= topbarH) {
        // At top of page: header follows the topbar down so they appear together,
        // and we revert to the original (possibly transparent) styling.
        header.classList.remove('is-sticky', 'is-hidden', 'has-shadow');
        setTopOffset(topbarH - currentY);
        lastDirection = 0;
      } else {
        header.classList.add('is-sticky');
        setTopOffset(0);

        const delta = currentY - lastY;

        if (Math.abs(delta) > SCROLL_THRESHOLD) {
          if (delta > 0 && lastDirection !== 1) {
            lastDirection = 1;
            header.classList.add('is-hidden');
            header.classList.remove('has-shadow');
          } else if (delta < 0 && lastDirection !== -1) {
            lastDirection = -1;
            header.classList.remove('is-hidden');
            header.classList.add('has-shadow');
          }
        }
      }

      lastY = currentY;
      ticking = false;
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    function onResize() {
      if (window.scrollY <= topbarHeight()) {
        setTopOffset(topbarHeight() - window.scrollY);
      }
    }

    setTopOffset(topbarHeight());
    update();

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize, { passive: true });
  }

  function init() {
    initMenuDrawer();
    initLocaleSwitcher();
    initHeaderScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
